export default {"src":"/_next/static/media/cloud.8c2478bd.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};